import { render, staticRenderFns } from "./Playfield.vue?vue&type=template&id=4ad12e94&scoped=true&"
import script from "./Playfield.vue?vue&type=script&lang=js&"
export * from "./Playfield.vue?vue&type=script&lang=js&"
import style0 from "./Playfield.vue?vue&type=style&index=0&id=4ad12e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad12e94",
  null
  
)

export default component.exports